import { createContext } from 'react';

// Exposes MainLayout's scrollable `main` container ref (src/App.js) so
// nested components can reset scroll to top themselves — see
// useScrollToTopOnMount. Needed because some in-page view swaps (e.g.
// Project detail-view drill-downs) don't change location.pathname, so
// MainLayout's own pathname-driven scroll reset never fires for them.
export const ScrollContainerContext = createContext(null);

export default ScrollContainerContext;
